export default class {
	idPedido
	idsDocumentosPedido

	constructor(idPedido, idsDocumentosPedido) {
		this.idPedido = idPedido
		this.idsDocumentosPedido = idsDocumentosPedido
	}
}
